import { ApiExplorerInputType } from '@squareup/dex-types-shared-api-explorer';
import { getNextPublicDeveloperCDNURL } from '@squareup/dex-utils-environment';

interface SchemaDefinition {
  $id: string;
  description: string;
  type: string;
  maxLength?: number;
  pattern?: string;
  format?: string;
  properties?: Record<string, unknown>;
}

interface SchemaType {
  definitions: Record<string, SchemaDefinition>;
}

const CUSTOM_SCHEMA_KEY = 'Custom';

const SchemaCustomDefinition = {
  'squareup.common.Custom': {
    $id: '#squareup.common.Custom',
    description: 'Define your own schema.',
    type: 'object',
    maxLength: 1000,
  },
};

const getSchemaValueByKey = (key: string) => {
  if (key.length > 200) {
    // This shouldn't happen, but if it does, it's likely a maliciously long key
    // https://codeql.github.com/codeql-query-help/javascript/js-polynomial-redos/
    throw new Error('Unexpected schema key length');
  }
  // Parse the schema definition key to get the value
  // squareup.common.String -> String
  const keyRegex = /[^.]+$/;
  return key?.match(keyRegex)?.at(0) || key;
};

const parseSchemaValueFromCurrent = (currentValue: ApiExplorerInputType) => {
  if (currentValue === undefined) {
    return undefined;
  }
  if (
    currentValue &&
    typeof currentValue === 'object' &&
    '$ref' in currentValue
  ) {
    return getSchemaValueByKey((currentValue as { $ref: string }).$ref);
  }
  return CUSTOM_SCHEMA_KEY;
};

const constructSchemaWithRef = (value: string) => ({
  $ref: `${getNextPublicDeveloperCDNURL()}/schemas/v1/common.json#squareup.common.${value}`,
});

export {
  CUSTOM_SCHEMA_KEY,
  SchemaCustomDefinition,
  type SchemaType,
  getSchemaValueByKey,
  parseSchemaValueFromCurrent,
  constructSchemaWithRef,
};
